import * as React from "react";
const SvgAddBold = (props) => /* @__PURE__ */ React.createElement("svg", { className: "icon", style: {
  width: "1em",
  height: "1em",
  verticalAlign: "middle",
  fill: "currentColor",
  overflow: "hidden"
}, viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M874.666667 469.333333H554.666667V149.333333c0-23.466667-19.2-42.666667-42.666667-42.666666s-42.666667 19.2-42.666667 42.666666v320H149.333333c-23.466667 0-42.666667 19.2-42.666666 42.666667s19.2 42.666667 42.666666 42.666667h320v320c0 23.466667 19.2 42.666667 42.666667 42.666666s42.666667-19.2 42.666667-42.666666V554.666667h320c23.466667 0 42.666667-19.2 42.666666-42.666667s-19.2-42.666667-42.666666-42.666667z" }));
export default SvgAddBold;
